import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PlatformService } from 'src/app/core/services/platform/platform.service';

export const AuthGuard: CanActivateFn = (
  _next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  const platformService = inject(PlatformService);

  // Disable guard if it's server-side only
  if (!platformService.isBrowser()) {
    return true;
  }

  // Check localStorage directly like the old guard
  const isAuth = localStorage.getItem('userData');
  if (isAuth) {
    return true; // Allow access to protected routes
  }


  // Redirect to login with return URL to preserve user's intended destination
  return router.createUrlTree(['/auth/login-otp'], {
    queryParams: { returnUrl: state.url }
  });
};

